module.exports = __webpack_public_path__ + "img/3.69eacd92.jpg";